import { caCheckAtom } from '@/atoms/caCheck';
import { rugWalletAtom } from '@/atoms/rugWallet';
import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { formatReportText, formatTweetText } from '@/utils/formatText';
import { useAtomValue } from 'jotai';
import { FaXTwitter } from 'react-icons/fa6';
import { Skeleton } from '../ui/skeleton';

export const ShareX = () => {
  const caCheckResult = useAtomValue(caCheckAtom);
  const tokenInfoResult = useAtomValue(tokenInfoAtom);
  const rugWalletResult = useAtomValue(rugWalletAtom);
  const hasPastRug = rugWalletResult?.data ? rugWalletResult.data.length > 1 : false;

  if (!tokenInfoResult?.symbol || !caCheckResult?.score || !caCheckResult?.message)
    return (
      <Skeleton className="h-[42px] w-[110px] py-2 px-2 bg-white/30 border border-gray-800 rounded-full" />
    );
  return (
    <a
      href={`https://twitter.com/intent/tweet?text=${
        caCheckResult.score < 40
          ? formatReportText(
              tokenInfoResult.name,
              tokenInfoResult.ca,
              tokenInfoResult.symbol,
              caCheckResult.score,
              hasPastRug,
            )
          : formatTweetText(
              tokenInfoResult.symbol,
              caCheckResult.score,
              caCheckResult.message,
              tokenInfoResult.ca,
            )
      }`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 px-4 py-2 bg-black border border-gray-800 rounded-full hover:bg-gray-900 transition-colors"
    >
      <FaXTwitter className="h-4 w-4 text-gray-400" />
      <span className="font-medium text-gray-400">SHARE</span>
    </a>
  );
};
